export const storageMap = [
	{ key: '24 Hour Storage', label: '24 Hour Self Storage' },
	{
		key: 'Climate Controlled Storage',
		label: 'Climate Controlled Self Storage',
	},
	{ key: 'Drive-Up Access Storage', label: 'Drive Up Self Storage' },
	{
		key: 'Storage With Electricity',
		label: 'Self Storage with Electricity',
	},
	{ key: 'Wine Storage', label: 'Wine Self Storage' },

	{ key: 'Mini Storage Units', label: 'Mini Self Storage Units' },
	{ key: 'Small Storage Units', label: 'Small Self Storage Units' },
	{ key: 'Medium Storage Units', label: 'Medium Self Storage Units' },
	{ key: 'Large Storage Units', label: 'Large Self Storage Units' },
	{ key: 'Locker Storage', label: 'Self Storage Lockers' },

	{ key: 'Boat Storage', label: 'Self Storage for Boats' },
	{ key: 'Car Storage', label: 'Self Storage for Cars' },
	{ key: 'RV Storage', label: 'Self Storage for RVs' },
	{ key: 'Motorcycle Storage', label: 'Self Storage for Motorcycles' },
];
